import { Popup as SemanticPopup } from "semantic-ui-react";

export default function Popup({ position = "top center", size = "mini", ...props }) {
	return <SemanticPopup position={position} size={size} {...props} />;
}
